import { Button, IconButton, styled, Typography } from '@mui/material';

export const FromContainer = styled('div')`
  width: 671px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  border-radius: 15px;
  padding: 36px 25px;
  @media (max-width: 1023px) {
    width: 100%;
    padding: 16px 8px;
  }
`;

export const CloseButtonW = styled(IconButton)`
  margin-left: auto;
  position: fixed;
  top: 79px;
  right: 88px;
`;

export const PublicDocumentNote = styled(Typography)`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.primary.p040};
  white-space: break-spaces;

  @media (max-width: 1023px) {
    margin-top: 16px;
    font-size: 12px;
    line-height: 16px;
  }
`;

export const Footer = styled(Typography)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FormButtonsWrapper = styled('div')`
  display: flex;
  gap: 12px;
  margin-left: auto;
`;

export const CancelBtn = styled(Button)`
  text-transform: none;
  border-radius: 8px;
  padding: 10px 32px;
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.primary.p080};
  border-color: ${({ theme }) => theme.palette.primary.light};
  background: ${({ theme }) => theme.palette.white.main};

  &:hover {
    background: ${({ theme }) => theme.palette.white.p100};
    border-color: ${({ theme }) => theme.palette.primary.p030};
  }
`;

export const CreateBtn = styled(Button)`
  text-transform: none;
  border-radius: 8px;
  padding: 10px 32px;
  font-weight: 400;
  font-size: 14px;
  background: ${({ theme }) => theme.palette.info.main};
  color: ${({ theme }) => theme.palette.white.main};

  &:hover {
    background: ${({ theme }) => theme.palette.info.dark};
  }

  &:disabled {
    background: ${({ theme }) => theme.palette.info.p030};
    color: ${({ theme }) => theme.palette.white.main};
  }
`;

export const LabelW = styled('label')`
  font-weight: 500;
  font-size: 18px;
  line-height: 14px;
  width: 56px;
  max-width: 56px;
  white-space: nowrap;
  margin-left: 10px;
  color: ${({ theme }) => theme.palette.primary.main};

  @media (max-width: 1023px) {
    width: 48px;
  }
`;

export const InputW = styled('input')`
  width: 20px;
  height: 20px;
  accent-color: ${({ theme }) => theme.palette.info.main};
`;

export const CheckboxContainer = styled('div')`
  display: flex;
  align-items: center;
  padding-top: 10px;
`;

export const LabelTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '18px',
  lineHeight: '24px',
  color: theme.palette.primary.p080,
  marginBottom: '16px',
  marginLeft: '10px',
  [theme.breakpoints.down('desktop')]: {
    marginBottom: '8px',
  },
}));
